import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ContractsDirectKpiCfg, ContractsDirectKpiCfgService } from "./contractsDirectKpiCfg.service";
import { ContractsDirectKpiService, Range } from "./contractsDirectKpiService";
import { DateRange } from "./dateRange";

export class ContractDetail {
    public type: string;
    public unitId: string;
    public unitName: string;
    public userDocNumber: string;
    public userName: string;
    public beginDate: Date;
    public endDate: Date;
    public workerName: string;
    public workerEmail: string;
    public workerPhone: string;
    public clientFiscalName: string;
    public workerDocNumber: string;
    public workerId: number;
    public isWeb: string;
}

export class UnsignedContractsDirectDetailServiceData {
    public contracts: ContractDetail[];
    public updateTimestamp: Date;
}

export abstract class UnsignedContractsDirectDetailService extends ContractsDirectKpiService<UnsignedContractsDirectDetailServiceData> {

    protected abstract getRange(): DateRange;

    constructor(private serviceCfg: ContractsDirectKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(this.getRange());
    }

    protected async update(): Promise<UnsignedContractsDirectDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: UnsignedContractsDirectDetailServiceData = null;
            try {

                let cfg: ContractsDirectKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDates();
                let url = cfg.unsignedContractsDirect.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<UnsignedContractsDirectDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastUnsignedContractsDirectDetailService extends UnsignedContractsDirectDetailService {
    public getClassName() { return "PastUnsignedContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Past; }
}

@Injectable()
export class InmediateUnsignedContractsDirectDetailService extends UnsignedContractsDirectDetailService {
    public getClassName() { return "InmediateUnsignedContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}

@Injectable()
export class ForecastedUnsignedContractsDirectDetailService extends UnsignedContractsDirectDetailService {
    public getClassName() { return "ForecastedUnsignedContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Forecast; }
}

export class TodayTomorrowUnsignedContractsDirectDetailService extends UnsignedContractsDirectDetailService {
    public getClassName() { return "TodayTomorrowUnsignedContractsDirectDetailService"; }

    constructor(serviceCfg: ContractsDirectKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}
